import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React, { useState, useEffect } from "react";
import "../App.css";

const Data = [
  
  {
    imgUrl:
      "https://images.unsplash.com/photo-1489171078254-c3365d6e359f?q=80&w=1931&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Lounge Furniture",
    description:
      "Upgrade your lounge furniture with our customization expertise",
  },
  {
    imgUrl:
      "https://images.unsplash.com/photo-1621293954908-907159247fc8?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Lobby Furniture",
    description:
      "Upgrade your lobby furniture with our customization expertise",
  },
  {
    imgUrl:
      "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Restaurant Indoor",
    description:
      "Upgrade your restaurant furniture with our customization expertise",
  },
  {
    imgUrl:
      "https://images.unsplash.com/photo-1640303458653-f67c6eea8f80?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Pool Furniture",
    description:
      "Upgrade your pool furniture with our customization expertise ",
  },
  {
    imgUrl:
      "https://images.unsplash.com/photo-1618245318763-a15156d6b23c?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Beach Furniture",
    description:
      "Upgrade your beach furniture with our customization expertise",
  },
  {
    imgUrl:
      "https://images.unsplash.com/photo-1653581494409-270dfea9f0b0?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Garden Furniture",
    description:
      "Upgrade your garden furniture with our customization expertise",
  },
  {
    imgUrl:
      "https://images.unsplash.com/photo-1559339352-11d035aa65de?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Restaurant Outdoor",
    description:
      "Upgrade your outdoor furniture with our customization expertise",
  },
  {
    imgUrl:
      "https://images.unsplash.com/photo-1605205187194-b335378e3697?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Street Furniture",
    description:
      "Upgrade your street furniture with our customization expertise",
  },
  {
    imgUrl:
      "https://images.unsplash.com/photo-1604328698692-f76ea9498e76?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Office Furniture",
    description:
      "Upgrade your room furniture with our customization expertise",
  },
  {
    imgUrl:
      "https://images.unsplash.com/photo-1512678080530-7760d81faba6?q=80&w=2074&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Health Furniture",
    description:
      "Upgrade your health furniture with our customization expertise ",
  },
  {
    imgUrl:
      "https://images.unsplash.com/photo-1580582932707-520aed937b7b?q=80&w=1932&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Education Furniture",
    description:
      "Upgrade your education furniture with our customization expertise ",
  },{
    imgUrl:
      "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Room Furniture",
    description:
      "Upgrade your room furniture with our customization expertise ",
  }
];

function SimpleSlider() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 640);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 640);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function NextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={`${className} custom-arrow next-arrow sm:block hidden`} // This hides the arrow by default and shows it on 'sm' screens and above
        style={{ ...style, display: "block" }} // Keep your existing inline styles
        onClick={onClick}
      />
    );
  }

  function PrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={`${className} custom-arrow prev-arrow sm:block hidden`} // This hides the arrow by default and shows it on 'sm' screens and above
        style={{ ...style, display: "block" }} // Keep your existing inline styles
        onClick={onClick}
      />
    );
  }

  const settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: isSmallScreen ? <></> : <NextArrow />,
    prevArrow: isSmallScreen ? <></> : <PrevArrow />,
    autoplay: true,
    autoplaySpeed: 4000,
    rtl: true, //
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="h-2/4 m-auto ">
      <Slider {...settings}>
        {Data.map((d) => (
          <div className="slide-animation relative ">
            <div className="h-[93vh] md:h-[100vh] flex justify-center items-center">
              <img
                className="w-full h-full object-cover"
                src={d.imgUrl}
                alt="img"
              />
            </div>

            {/* small screens slider */}

            <div className="absolute left-1/2 transform -translate-x-1/2 top-[40%] md:top-[50%] backdrop-blur-[2px] bg-opacity-40 w-[80%] md:w-[60%] sm:w-[70%] text-center lg:text-left bg-gray-100 rounded-xl md:hidden">
  <h1 className="uppercase mb-8 text-4xl lg:text-4xl font-md text-primary">
    {d.title}
  </h1>
  <h3 className="text-2xl lg:text-lg font-lg text-gray-700">
    {d.description}
  </h3>
</div>

{/* large screens slider */}
<div className=" lg:bg-opacity-50 backdrop-blur-[2px] lg:h-auto lg:w-[17%] md:w-auto md:h-auto md:bg-opacity-50 absolute left-[5%] top-[70%] transform -translate-y-1/2 bg-gray-100 rounded-full overflow-hidden p-8 text-center lg:text-left hidden md:block">
<h1 className="uppercase mb-5 text-xl lg:text-[25px] font-semibold text-primary text-center w-auto m-auto">
  {d.title}
</h1>
<h3 className="p-auto text-xl lg:text-lg font-semibold text-gray-700 text-center">
  {d.description}
</h3>
</div>
        </div>
      ))}
    </Slider>
  </div>
);
}

export default SimpleSlider;
